import StockAddressingFileInput from './StockAddressingFileInput'

export default StockAddressingFileInput
